export default {"src":"/_next/static/media/fire-pit.10fad8a5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};